export * from './ContactDetailsUI.interface';
export * from './ContactDetailsUI';
